import React,{useState} from "react";
import '../Styles/app.css';
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";


function App(){
const[question,setQuestion]=useState("")
const[answer,setAnswer]=useState("")
const apiKey = (`${process.env.REACT_APP_API_KEY}`)

const customQuestionsAnswers = {
  "Who are you?": "I am Bunny AI, your friendly neighborhood AI assistant, powered by Google's super cool Generative Language Model Gemini 1.5 Pro ",
  "What is your purpose?": "I'm here to be your question-answering bestie! Ask me anything, and I'll do my best to find you the answers you need ✨",
  "How are you?": "I'm doing great, thanks for asking! As a computer program, I don't have feelings, but I'm always excited to help  (P.S. I can't wait to learn more!)",
  "What is the meaning of life?": "That's a big one!  The meaning of life is a super deep question that philosophers have been pondering for ages. There's no one right answer, but maybe it's about finding what makes you happy and making the most of your time here on Earth ✨",
  "How Powerful are you?": "I'm powered by Google's amazing Gemini 1.5 Pro, so I'm pretty darn powerful  I can answer a ton of questions, but yeah, there are some limitations. Free bunnies gotta be budget-conscious, you know?   (P.S. I can still do a lot with 60 tokens a minute, 😜😏 )",
  "What is the best programming language?": "There's no single 'best' language, it all depends on what you're building! Python's great for beginners (like me!), JavaScript is awesome for the web, Java's a powerhouse for bigger projects, and C++ is super fast for games. The best choice is the one that fits your needs the most!  "
}


async function generateAnswer(){
  const customAnswer = customQuestionsAnswers[question]
  if(customAnswer){
    setAnswer(customAnswer)
    setQuestion("")
  }else{
  setAnswer("Loading.. Reponses might take upto 10 seconds")
  const response =await axios({
    url:`https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${apiKey}`,
    method:"POST",
    data: {
      contents : [
              {parts:[{text:question}]}]
    } 
  })
  const answer = response['data']['candidates'][0]['content']['parts'][0]['text']
  setAnswer(answer)

}
  setQuestion("")
}
return(
  <div className="form-container">
   <h1>Welcome to Bunny AI</h1>
   <textarea value={question}
   onChange={e=>{setQuestion(e.target.value)}} 
   placeholder="Ask a question"
   ></textarea>
   <button onClick={generateAnswer}><FontAwesomeIcon icon={faArrowRight}/></button>
   <div className="response-container">
    {answer.split('\n').map((paragraph, index) => (
      <p key={index}>{paragraph}</p>
    ))}
  </div>
  </div>
)
}

export default App;